import { Component, OnInit } from '@angular/core';
import { CustomDataService } from '../services/custom-data.service';

@Component({
  selector: 'tweets',
  templateUrl: './tweets.component.html',
  styleUrls: ['./tweets.component.css']
})
export class TweetsComponent implements OnInit {
tweetsData 
  constructor(private tweet:CustomDataService)
   {
    this.tweetsData = this.tweet.tweets ; 
   }

  ngOnInit() {
  }

}
